import Api from '../api'

export default {
    getLanding(id) {
        return Api.get(`/PublicApi/GetLanding?id=${id}`)
    }
}